import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import SubsidiesSection from './components/SubsidiesSection';
// import ProjectsSection from './components/ProjectsSection'; // Masqué temporairement - en attente de photos professionnelles
import CTASection from './components/CTASection';
import AboutSection from './components/AboutSection';
import RecruitmentSection from './components/RecruitmentSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <SubsidiesSection />
        {/* Section Réalisations masquée - à réactiver avec photos professionnelles */}
        {/* <ProjectsSection /> */}
        <CTASection />
        <AboutSection />
        <RecruitmentSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
